exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-name[data-v-17ce93ad]{display:flex;flex:1}.wrap-name[data-v-17ce93ad],.wrap-name .intv-name[data-v-17ce93ad]{white-space:nowrap;overflow:hidden}.wrap-name .intv-name[data-v-17ce93ad]{text-overflow:ellipsis}.disabledBg[data-v-17ce93ad]{background-color:#fff}", ""]);

// exports
